import { render, staticRenderFns } from "./PageCompleteRegistration.vue?vue&type=template&id=3a27b158&"
import script from "./PageCompleteRegistration.vue?vue&type=script&lang=js&"
export * from "./PageCompleteRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports